import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=4b8cbb7c&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=4b8cbb7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cbb7c",
  null
  
)

component.options.__file = "Permissions.vue"
export default component.exports